'use strict';

function LessonResource($resource, API) {
    var urlApi = API.course + '/lessons';
    return $resource(urlApi, {}, {
        delete: {
            method: 'DELETE',
            url: urlApi + '/:id',
            transformResponse: function (data, headersGetter, status) {
                return {
                    status: status,
                    data: data,
                    headers: headersGetter()
                };
            }
        }
    });
}

angular
    .module('lmsApp')
    .factory('LessonResource', LessonResource);